import ConfirmTerms from './ConfirmTerms';

export default ConfirmTerms;
